import {rootReducer} from './reducers';

export type AppState = ReturnType<typeof rootReducer>;

export const {configureStore} =
  process.env.NODE_ENV === 'development'
    ? require('./index.dev')
    : require('./index.prod');
